import { PopupMessageDefaultConfig } from "sb-resp-ui";
import { getPopupActionsConfig } from "../getPopupActionsConfig";
import { deepMerge } from "sb-helpers";
export const getPopupMessageConfig = (config, context) => {
    var popupMessageConfig = deepMerge(PopupMessageDefaultConfig, {});
    config.header && (popupMessageConfig.header = config.header);
    config.wrapperClassname && (popupMessageConfig.className = config.wrapperClassname);
    config.body && (popupMessageConfig.body = config.body);
    config.type && (popupMessageConfig.type = config.type);
    if (typeof config.actions === "object") {
        popupMessageConfig.actions = getPopupActionsConfig(config.actions, context);
    }
    return popupMessageConfig;
};
//# sourceMappingURL=getPopupMessageConfig.js.map